var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-12 w-full p-2 bg-white flex items-center"},[_c('b-progress',{staticClass:"h-5 w-full",attrs:{"type":"is-success","size":"is-medium","value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }